module.exports = __webpack_public_path__ + "img/35.1f13e730.jpg";